export default __webpack_public_path__ + "25a66e56af15307808a97b390333ce73.png";